import * as React from 'react';

interface IOrderContainerProps {
  order: number;
}

export function OrderWrapper({ order, children }: React.PropsWithChildren<IOrderContainerProps>) {
  return <div style={{ order }}>{children}</div>;
}
